<template>
  <v-combobox
    multiple
    id="municipio-select"
    v-model="filter.municipio"
    item-text="nome"
    item-name="municipioId"
    :items="municipios"
    label="Município"
    placeholder="Município"
    @change="$emit('changeCity')"
    :return-object=true
    clearable
  >
    <template slot="no-data">
      Nenhum Município retornado
    </template>
  </v-combobox>
</template>

<script>
import { cityAPI } from '@/modules/city'

export default {
  name: 'AppCityCombobox',
  props: [
    'filter'
  ],
  mounted () {
    this.loadCities()
  },
  methods: {
    loadCities () {
      cityAPI.listNames()
        .then(resp => {
          this.municipios = resp.data
        })
        .catch()
    }
  },
  data () {
    return {
      municipios: []
    }
  }
}
</script>
